import { Box, Menu, MenuItem } from '@mui/material'
import { useState } from 'react'
import { Trans } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { SortButton } from '~/components/SortButton'
import { CommentListSortTypeAtom } from '~/features/video_detail/atoms/CommentListSortTypeAtom'
import { Colors } from '~/libs/mui/theme'
import { COMMENT_LIST_SORT_TYPE_LIST, CommentListSortType } from './constants'

export function CommentSortButton(): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [commentListSortType, setCommentListSortType] = useRecoilState(CommentListSortTypeAtom)

  const selectMenu = (type: CommentListSortType) => {
    setCommentListSortType(type)
    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const open = Boolean(anchorEl)

  return (
    <Box>
      <SortButton onClick={handleClick} sortName={commentListSortType} />
      <Menu open={open} elevation={0} anchorEl={anchorEl} onClose={handleClose}>
        {COMMENT_LIST_SORT_TYPE_LIST.map((item, idx) => (
          <MenuItem
            key={idx}
            onClick={() => selectMenu(item)}
            sx={{
              py: 1,
              color: commentListSortType === item ? Colors.colorD0DF00 : undefined,
              fontWeight: 'bold',
            }}
          >
            <Trans i18nKey={item} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
